import { createApp } from "vue"
import router from "../router"
import { showDialog } from 'vant'
import axios from "../commons/AxiosMethod.js"
import store from '../store'
const tools = {
  DialogConfirm(title, message, then, catchs) {
    showDialog({
      title: title,
      message: message
    })
      .then(then)
      .catch(catchs)
  },

  ToPage(url) {
    router.push({
      name: "ProductDetail",
      query: { Id: this.Product.Id }
    })
  },
  S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  },
  guid() {
    return (
      this.S4() +
      this.S4() +
      "-" +
      this.S4() +
      "-" +
      this.S4() +
      "-" +
      this.S4() +
      "-" +
      this.S4() +
      this.S4() +
      this.S4()
    )
  },
  // 获取语言值
  GetLanguageValue(key) {
    try {
      var languageMap = JSON.parse(localStorage.getItem("LanguageRepertory"))

      var val = languageMap[key]
      if (!val) {
        val = key

        console.log("当前是："+process.env.VUE_APP_BASE_API)

        //去后台创建Key
        if (process.env.VUE_APP_BASE_API == "development") {
          // 如果table是guid，那么开始验证
          axios.apiMethod(
            "/admins/Languages/InsertResourceKey",
            "get",
            {
              resourceKey: key
            },
            (result) => {

            }
          );
        }

      }
      return val
    } catch (e) {

    }
  },  // 获取购物车
  GetShoppingCartComplete(tableId) {
    axios.apiMethod(
      "/Store/StoreOrder/GetShoppingCart",
      "get",
      {
        TableId: tableId
      },
      (result) => {
        var carts = result.Data

        store.commit({
          type: 'updateCart',
          carts: carts
        })
      },
      (e) => { }
    )
  }
}

export default tools

// export default tools;

